/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Timecodes_Copied_SuccessInputs */

const en_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecodes copied successfully`)
};

const fr_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecodes copiés avec succès`)
};

const de_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Zeitcodes erfolgreich kopiert`)
};

const it_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timecode copiati correttamente`)
};

const ru_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Временные метки успешно скопированы.`)
};

const es_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de tiempo copiados exitosamente`)
};

const zh_cn2_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`时间码已成功复制`)
};

const ja_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`タイムコードが正常にコピーされました`)
};

const hi_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टाइमकोड सफलतापूर्वक कॉपी हो गए`)
};

const pt_pt2_timecodes_copied_success = /** @type {(inputs: Timecodes_Copied_SuccessInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Códigos de tempo copiados com sucesso.`)
};

/**
* | output |
* | --- |
* | "Timecodes copied successfully" |
*
* @param {Timecodes_Copied_SuccessInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const timecodes_copied_success = /** @type {((inputs?: Timecodes_Copied_SuccessInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Timecodes_Copied_SuccessInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_timecodes_copied_success(inputs)
	if (locale === "de") return de_timecodes_copied_success(inputs)
	if (locale === "it") return it_timecodes_copied_success(inputs)
	if (locale === "ru") return ru_timecodes_copied_success(inputs)
	if (locale === "es") return es_timecodes_copied_success(inputs)
	if (locale === "zh-CN") return zh_cn2_timecodes_copied_success(inputs)
	if (locale === "ja") return ja_timecodes_copied_success(inputs)
	if (locale === "hi") return hi_timecodes_copied_success(inputs)
	if (locale === "pt-PT") return pt_pt2_timecodes_copied_success(inputs)
	return en_timecodes_copied_success(inputs)
});